// extracted by mini-css-extract-plugin
export default {"root":"AmenityCategoryAccordion_root__SU9cd"};